import { useContext } from 'react'
import { AppContext } from 'core'

export const PaymentSuccess = () => {
  const { notifier, history } = useContext(AppContext)
  notifier.success('Payment successfully processed')
  history.push('/')
  return null
}
